import { Timestamp } from "../../common";
import { FareclassShelfBrandName, ITripTerminus } from "../../flights-module";
import { HotelStarRatingEnum } from "../../hotels-module";

export enum TopAmenityEnum {
  Restaurant = "Restaurant",
  FreeWifi = "FreeWifi",
  ParkingIncluded = "ParkingIncluded",
  TwentyFourSevenFrontDesk = "TwentyFourSevenFrontDesk",
  Pool = "Pool",
  Bar = "Bar",
  PetFriendly = "PetFriendly",
  BusinessServices = "BusinessServices",
  AirportShuttle = "AirportShuttle",
  Laundry = "Laundry",
  Spa = "Spa",
  Gym = "Gym",
  Accessibility = "Accessibility",
  AdultsOnly = "AdultsOnly",
  BreakfastAvailable = "BreakfastAvailable",
  ParkingAvailable = "ParkingAvailable",
}

export interface UserHotelPreferencesPayload {
  starRatings: HotelStarRatingEnum[];
  amenities: TopAmenityEnum[];
  freeCancellationOnly: boolean;
}

export enum AirlineOpenEnum {
  AA = "AA",
  B6 = "B6",
  DL = "DL",
  ExcludeLcc = "ExcludeLcc",
  F9 = "F9",
  NK = "NK",
  UA = "UA",
}

export type FareclassOptionFilter = {
  [key in FareclassShelfBrandName]: boolean;
};

export interface UserFlightPreferencesPayload {
  homeAirport?: ITripTerminus;
  fareClasses: FareclassOptionFilter;
  airlines: AirlineOpenEnum[];
  nonStopOnly: boolean;
}

export enum UserPreferenceKeyEnum {
  hasSeenStaysVrFtux = "hasSeenStaysVrFtux",
  hasSeenWishlistsFtux = "hasSeenWishlistsFtux",
  hasSeenStayTypeVrFtux = "hasSeenStayTypeVrFtux",
  hasSeenPackagesFtux = "hasSeenPackagesFtux",
  hasSeenActivitiesFtux = "hasSeenActivitiesFtux",
  hasAnsweredActivitiesSurvey = "hasAnsweredActivitiesSurvey",
  lastSeenActivitiesSurvey = "lastSeenActivitiesSurvey",
  userHasVisitedActivityShopPage = "userHasVisitedActivityShopPage",
  creditCampaignFtux = "creditCampaignFtux",
  hasSeenTravelAppFtux = "hasSeenTravelAppFtux",
  hasSeenMyTripsCsatSurveyV1 = "hasSeenMyTripsCsatSurveyV1",
  hasSubmittedPayFlexSurvey = "hasSubmittedPayFlexSurvey",
  hasSubmittedCarsTripProtectionSurvey = "hasSubmittedCarsTripProtectionSurvey",
  hasSubmittedFlightsTripProtectionSurvey = "hasSubmittedFlightsTripProtectionSurvey",
  hasSeenTripsReplatformBanner = "hasSeenTripsReplatformBanner",
}

interface CreditCampaignFtuxPayload {
  hasSeen: boolean;
  caponeCreditId: string;
}

export interface UserPreferenceMetadataPayload {
  hasSeenStaysVrFtux?: boolean;
  hasSeenWishlistsFtux?: boolean;
  hasSeenStayTypeVrFtux?: boolean;
  hasSeenPackagesFtux?: boolean;
  hasSeenActivitiesFtux?: boolean;
  hasAnsweredActivitiesSurvey?: boolean;
  lastSeenActivitiesSurvey?: string;
  userHasVisitedActivityShopPage?: boolean;
  creditCampaignFtux?: CreditCampaignFtuxPayload[];
  hasSeenTravelAppFtux?: boolean;
  hasSeenMyTripsCsatSurveyV1?: boolean;
  hasSubmittedPayFlexSurvey?: boolean;
  hasSubmittedCarsTripProtectionSurvey?: boolean;
  hasSubmittedFlightsTripProtectionSurvey?: boolean;
  hasSeenTripsReplatformBanner?: boolean;
}

export interface GetUserMetadataRequest {
  keys: (keyof typeof UserPreferenceKeyEnum)[];
}

export interface GetUserMetadataResponse {
  userMetadata: UserPreferenceMetadataPayload;
  lastUpdatedAt: Timestamp;
}

export interface UpdateUserMetadataRequest {
  userMetadata: UserPreferenceMetadataPayload;
}

export interface UpdateUserMetadataResponse {
  value: {};
  Response: "Success" | "Failed";
}

export interface UpdateUserCreditCampaignFtuxMetadataRequest
  extends CreditCampaignFtuxPayload {}

export interface UpdateUserCreditCampaignFtuxMetadataResponse
  extends UpdateUserMetadataResponse {}
